import request from "project-config/services/request/request";
import { isDev, isLocalhost } from "project-config/utils/env";
import { useInvoiceStore } from "../store/invoice-store";

export function useHandleOpenInvoice() {
  const {
    orderSelectIds,
    setOrderSelectIds,
    setOrderSelectSum,
    setOpenCompanyChangeModal,
    setTipDate,
  } = useInvoiceStore();

  const handleOpenInvoice = async () => {
    const { data, code } = await request.post(
      "/api/rendering/user/getTokenUserInvoice",
      { transactOrderNumbers: orderSelectIds }
    );
    if (code === 993 && data) {
      setOpenCompanyChangeModal(true);
      setTipDate(data);
      return;
    }
    if (code === 200 && data) {
      const host = isLocalhost()
        ? "http://127.0.0.1:3001"
        : `https://${isDev() ? "account-pre" : "account"}.renderbus.com`;
      const link = `${host}/invoice?token=${data.rsAuthToken}`;
      const windowReference = window.open(link);
      if (windowReference === null) {
        window.location.href = link;
      }
      setOrderSelectIds([]);
      setOrderSelectSum(0);
    }
  };
  return {
    handleOpenInvoice,
  };
}
